import axios from "axios";
import { baseURL } from "../../../base-url.js";

export default {
  async createCost(_, costData) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.post(baseURL + "/cost/createCost", costData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  async updateCost(_, costData) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.put(baseURL + "/cost/updateCost", costData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  async loadCostsToday({ commit }, salonId) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(`${baseURL}/cost/getSalonAllCostsToday`, {
        params: { salonId },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setCosts", response.data);
    } catch (error) {
      console.error("Błąd ładowania dzisiejszych kosztów:", error);
    }
  },

  async loadSalonCostsByDate({ commit }, { salonId, startDate, endDate }) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(`${baseURL}/cost/getSalonAllCostsByDate`, {
        params: { salonId, startDate, endDate },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setCosts", response.data);
    } catch (error) {
      console.error("Błąd ładowania kosztów:", error);
    }
  },

  async loadTenantCostsByDate({ commit }, params) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.get(`${baseURL}/cost/getTenantCostsByDate`, {
        params: {
          startDate: params.startDate,
          endDate: params.endDate
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setCosts", response.data);
    } catch (error) {
      console.error("Błąd ładowania kosztów:", error);
    }
  }
  
}
